var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 23.868 23.868",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m100.95 1011a10.245 10.245 0 0 0-20.489 0 10.245 10.245 0 0 0 20.489 0z",
    display: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "powerclip",
    d: "m62.176 981.46h57.065v77.09h-57.065zm38.777 29.539a10.245 10.245 0 0 0-20.489 0 10.245 10.245 0 0 0 20.489 0z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.26313 0 0 .26313 -11.934 -259.57)",
    d: "m90.709 986.46-7.3709 1.0586-6.231 3.0047-4.8947 4.6944-3.3723 6.1274-1.6636 7.3039 0.23124 8.2238 2.3123 8.8872 4.5797 9.2941 7.0332 9.4443 9.3761 9.0515 9.3761-9.0515 7.0332-9.4443 4.5797-9.2941 2.3123-8.8872 0.23124-8.2238-1.6636-7.3039-3.3723-6.1274-4.8947-4.6944-6.231-3.0047z",
    clipPath: "url(#clipPath8)",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m15.599 16.88 3.4025 1.4339-7.0672 3.3526-7.0672-3.3526 3.4025-1.4339-0.30079-0.29037-0.987-1.3254-6.9818 2.9423 11.934 5.6615 11.934-5.6615-6.9818-2.9423-0.987 1.3254z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.831bf8af79bf7515a1812ee84416e3f3.svg";
export { ForwardRef as ReactComponent };